'use strict';
import moment from 'moment';

export default function formatDate(date) {
    date = (new Date(date)).toISOString();
    return moment(date).format('DD/MM/YYYY HH:mm:ss');
}